export default {"src":"/_next/static/media/h2uRed.dc1593ec.svg","height":40,"width":89,"blurWidth":0,"blurHeight":0};